import React from 'react';
import { IconType } from '../Icon';
import IconButton, { IconButtonTemplateProps } from '../IconButton';

export default function DeleteIconButton(props: IconButtonTemplateProps) {
  return (
    <IconButton
      type={IconType.trash1}
      stroke='stroke-body hover:stroke-error-500'
      className='hover:bg-transparent'
      {...props}
    />
  );
}
